const ASSETS_TABLE_READY = "assets-table-ready"
const SEARCH_TEXT_STATE = "assets-table-search-text-state"
const ROWS_PER_PAGE_STATE = "assets-table-rows-per-page-state"
const PAGINATION_STATE = "assets-table-pagination-state"

const ASSET_ID_FOR_ACTION = "assets-table-asset-id-for-action"

const ADD_EDIT_ASSET_READY = "add-edit-asset-ready"


const PREVIOUS_ASSET_FILTER_STATUS = "previous-asset-filter-status-action"

const PREVIOUS_ASSET_FILTER_VENDOR_ID = "previous-asset-filter-vendor-id-action"


const PREVIOUS_ASSETS_WORK_LOCATION_TYPE = "assets-previous-work-location-type"
const PREVIOUS_ASSETS_WORK_LOCATION_ID = "assets-previous-work-location-id"



const initialState = {
    isAssetsTableReady: true,
    isAddEditAssetReady:true,
    assets: {},

    
    assetSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterVendor : "",


    previousWorkLocationType: "",
    previousWorkLocationId: "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ASSETS_TABLE_READY:
            return Object.assign({}, state, { isAssetsTableReady: action.payload })
        case ADD_EDIT_ASSET_READY:
            return Object.assign({}, state, { isAddEditAssetReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ASSET_ID_FOR_ACTION:
            return Object.assign({}, state, {assetSelectedId:action.payload})

        case PREVIOUS_ASSET_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_ASSET_FILTER_VENDOR_ID:
            return Object.assign({}, state, {previousFilterVendor:action.payload})



        case PREVIOUS_ASSETS_WORK_LOCATION_TYPE:
            return Object.assign({}, state, {previousWorkLocationType:action.payload})
        case PREVIOUS_ASSETS_WORK_LOCATION_ID:
            return Object.assign({}, state, {previousWorkLocationId:action.payload})


        default:
        return state
    
    }

}

export function assetsTableReady(data) {
    return {
        type: ASSETS_TABLE_READY,
        payload: data
    }
}


export function addEditAssetReady(data) {
    return {
        type: ADD_EDIT_ASSET_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function assetIdForAction(assetId){
    return{
        type:ASSET_ID_FOR_ACTION,
        payload:assetId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_ASSET_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterVendor(filterVal){
    return{
        type:PREVIOUS_ASSET_FILTER_VENDOR_ID,
        payload:filterVal
    }
}


export function previousWorkLocationType(fiter_val){
    return{
        type:PREVIOUS_ASSETS_WORK_LOCATION_TYPE,
        payload:fiter_val
    }
}


export function previousWorkLocationId(fiter_val){
    return{
        type:PREVIOUS_ASSETS_WORK_LOCATION_ID,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Assets/redux/assets.js